import { render, staticRenderFns } from "./signin.vue?vue&type=template&id=10dc33a0&scoped=true&"
import script from "./signin.vue?vue&type=script&lang=js&"
export * from "./signin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dc33a0",
  null
  
)

export default component.exports